import React from "react";
import "../../../css/DesignSystem/Buttons/IconButton.css";

const IconButton = ({
  icon,
  onClick,
  disabled = false,
  label,
  loadingLabel = "Loading...",
  loading = false,
  className = "",
}) => {
  const accessibleLabel = loading ? loadingLabel : label;

  return (
    <button
      type="button"
      className={`ds-icon-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled || loading}
      aria-label={accessibleLabel}
      title={accessibleLabel}
    >
      {icon}
    </button>
  );
};

export default IconButton;
